/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentUploadResponseDto } from '../models/document-upload-response-dto';
import { upload } from '../fn/document/upload';
import { Upload$Params } from '../fn/document/upload';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  /** Path part for operation `upload()` */
  static readonly UploadPath = '/api/Document/upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload$Response(
    params: Upload$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<DocumentUploadResponseDto>> {
    return upload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  upload(params: Upload$Params, context?: HttpContext): Observable<DocumentUploadResponseDto> {
    return this.upload$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentUploadResponseDto>): DocumentUploadResponseDto => r.body)
    );
  }
}
